import React, { useEffect, useState } from 'react';
import includes from 'lodash/includes';
import { withRouter, Link } from 'react-router-dom';
import { ReactComponent as UserLogo } from '../../styles/assets/user.svg';
import { ReactComponent as BankLogo } from '../../styles/assets/bank.svg';
import { ReactComponent as AmountLogo } from '../../styles/assets/amount.svg';
import { ReactComponent as ContactSupport } from '../../styles/assets/support.svg';
import { ReactComponent as LogOut } from '../../styles/assets/logout.svg';
import { useAuth0 } from '../../react-auth0-spa.js';
import { clearStore } from '../../utils/util';
import { ReactComponent as NewTransferActive } from '../../styles/assets/New-transfer-active.svg';
import css from '../../styles/modules/Menu/menu.module.css';
import './menuNavBar.css';
import { MdAttachMoney } from 'react-icons/md';
import { RiLogoutBoxRLine } from 'react-icons/ri';
import { makeStyles } from '@material-ui/core/styles';
import useWindowWidth from '../../hooks/nonGQLhooks/useWindowWidth';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector, useDispatch } from 'react-redux';
import { closeNavbar, openNavbar } from '../../reducers/navbar/navbarActions';
import { useSelect } from '@mui/base';

const account = '/account';
const bankAccounts = '/bank-accounts';
const transfers = '/transfer-history';
const message = '/message-center';
const newTransferStart = [
  '/create-account/step-select-account',
  '/create-account/step-select-account',
  '/create-account/step-3',
];

const MenuNavBar = (props) => {
  const dispatch = useDispatch();
  const { isClosed } = useSelector((state) => state.navbar);

  const pathname = window.location.pathname;
  const history = useHistory();
  const [fontColor, setFontColor] = useState('');
  const isMobile = window.screen.width < 768;
  //IMPORTANT - OPEN === true is false!! Legacy code error

  const isSelectedAccount = history?.location?.pathname === '/account';
  const isSelectedBank = includes(bankAccounts, pathname);
  const isSelectedTransfer = includes(transfers, pathname);

  const isNewTransfer = includes(newTransferStart, pathname);
  const windowWidth = useWindowWidth();

  const { logout } = useAuth0();
  const userLogout = () => {
    logout();
    clearStore();
  };

  useEffect(() => {
    if (isMobile) {
      dispatch(closeNavbar());
    }
  }, [isMobile]);

  useEffect(() => {
    if (props?.branding) {
      setFontColor(props?.branding?.fontColor);
    } else {
      setFontColor('black');
    }
  }, [props]);

  if (props.hide) {
    return props.children;
  }

  let accentColor = props?.branding?.accentColor || '#000000';

  const handleEmailClick = () => {
    window.location.href = 'mailto:support@certifid.com';
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+16168161668';
  };

  function returnLinkItems() {
    if (!isMobile) {
      return (
        <>
          <div
            style={{ cursor: 'pointer' }}
            className={css.reactDomLinkEl}
            onClick={() => history.push('/account')}
          >
            <div
              style={
                isSelectedAccount
                  ? { backgroundColor: 'rgba(255, 255, 255, 0.7)' }
                  : {}
              }
              className={css.menuItemContainer}
            >
              <UserLogo className={css.icon} fill={fontColor} />
              <p
                className={isClosed ? css.menuTextHidden : css.menuText}
                style={{ color: fontColor }}
              >
                My Account
              </p>
            </div>
          </div>

          <div
            style={{ cursor: 'pointer' }}
            className={css.reactDomLinkEl}
            onClick={() => history.push('/create-account/step-3')}
          >
            <div
              style={
                isNewTransfer
                  ? { backgroundColor: 'rgba(255, 255, 255, 0.7)' }
                  : {}
              }
              className={css.menuItemContainer}
            >
              <NewTransferActive className={css.icon} fill={fontColor} />
              <p
                className={isClosed ? css.menuTextHidden : css.menuText}
                style={{ color: fontColor }}
              >
                New Payment
              </p>
            </div>
          </div>

          <div
            style={{ cursor: 'pointer' }}
            className={css.reactDomLinkEl}
            onClick={() => history.push('/bank-accounts')}
          >
            <div
              style={
                isSelectedBank
                  ? { backgroundColor: 'rgba(255, 255, 255, 0.7)' }
                  : {}
              }
              className={css.menuItemContainer}
            >
              <BankLogo className={css.icon} fill={fontColor} />
              <p
                className={isClosed ? css.menuTextHidden : css.menuText}
                style={{ color: fontColor }}
              >
                Bank Account
              </p>
            </div>
          </div>

          <div
            style={{ cursor: 'pointer' }}
            className={css.reactDomLinkEl}
            onClick={() => history.push('/transfer-history')}
          >
            <div
              style={
                isSelectedTransfer
                  ? { backgroundColor: 'rgba(255, 255, 255, 0.7)' }
                  : {}
              }
              className={`${css.menuItemContainer} ${
                isSelectedAccount ? 'selected' : ''
              }`}
            >
              <MdAttachMoney fill={fontColor} className={css.amountIcon} />
              <p
                style={{ color: fontColor }}
                className={isClosed ? css.menuTextHidden : css.menuText}
              >
                Transactions
              </p>
            </div>
          </div>

          <div
            onClick={() => userLogout()}
            className={css.menuItemContainer}
            style={{ cursor: 'pointer' }}
          >
            <RiLogoutBoxRLine fill={fontColor} className={css.logoutIcon} />
            <p
              style={{ color: fontColor }}
              className={isClosed ? css.menuTextHidden : css.menuText}
            >
              Logout
            </p>
          </div>

          <div
            style={{
              overflow: 'hidden',
              border: `1px solid ${fontColor}`,
            }}
            className={css.horizontalLine}
          ></div>

          <div className={css.menuItemContainer} style={{ cursor: 'pointer' }}>
            <ContactSupport
              className={css.contactSupportIcon}
              fill={fontColor}
            />
            <p
              className={isClosed ? css.menuTextHidden : css.menuText}
              style={{ color: fontColor }}
            >
              Contact Support
            </p>
          </div>

          <div
            style={{ color: fontColor }}
            className={css.supportItemsContainer}
          >
            {!isClosed ? (
              <span style={{ color: fontColor }} className={css.supportItems}>
                <span
                  style={{ color: fontColor, cursor: 'pointer' }}
                  className={css.supportItems}
                  onClick={handleEmailClick}
                >
                  support@certifid.com
                </span>
                <br />
                <span
                  style={{ color: fontColor, cursor: 'pointer' }}
                  className={css.supportItems}
                  onClick={handlePhoneClick}
                >
                  1-616-816-1668
                </span>
              </span>
            ) : null}
          </div>
        </>
      );
    } else if (isMobile) {
      if (!isClosed) {
        return (
          <>
            <div
              style={{ cursor: 'pointer' }}
              className={css.reactDomLinkEl}
              onClick={() => history.push('/account')}
            >
              <div
                className={`${css.menuItemContainer} ${
                  isSelectedAccount ? 'selected' : ''
                }`}
              >
                <UserLogo className={css.icon} fill={fontColor} />
                <p
                  className={isClosed ? css.menuTextHidden : css.menuText}
                  style={{ color: fontColor }}
                >
                  My Account
                </p>
              </div>
            </div>

            <div
              style={{ cursor: 'pointer' }}
              className={css.reactDomLinkEl}
              onClick={() => history.push('/create-account/step-3')}
            >
              <div
                style={
                  isNewTransfer
                    ? { backgroundColor: 'rgba(255, 255, 255, 0.7)' }
                    : {}
                }
                className={css.menuItemContainer}
              >
                <NewTransferActive className={css.icon} fill={fontColor} />
                <p
                  className={isClosed ? css.menuTextHidden : css.menuText}
                  style={{ color: fontColor }}
                >
                  New Payment
                </p>
              </div>
            </div>

            <div
              style={{ cursor: 'pointer' }}
              className={css.reactDomLinkEl}
              onClick={() => history.push('/bank-accounts')}
            >
              <div
                style={
                  isSelectedBank
                    ? { backgroundColor: 'rgba(255, 255, 255, 0.7)' }
                    : {}
                }
                className={css.menuItemContainer}
              >
                <BankLogo className={css.icon} fill={fontColor} />
                <p
                  className={isClosed ? css.menuTextHidden : css.menuText}
                  style={{ color: fontColor }}
                >
                  Bank Account
                </p>
              </div>
            </div>

            <div
              style={{ cursor: 'pointer' }}
              className={css.reactDomLinkEl}
              onClick={() => history.push('/transfer-history')}
            >
              <div
                style={
                  isSelectedTransfer
                    ? { backgroundColor: 'rgba(255, 255, 255, 0.7)' }
                    : {}
                }
                className={`${css.menuItemContainer} ${
                  isSelectedAccount ? 'selected' : ''
                }`}
              >
                <MdAttachMoney fill={fontColor} className={css.amountIcon} />
                <p
                  style={{ color: fontColor }}
                  className={isClosed ? css.menuTextHidden : css.menuText}
                >
                  Transactions
                </p>
              </div>
            </div>

            <div onClick={() => userLogout()} className={css.menuItemContainer}>
              <RiLogoutBoxRLine fill={fontColor} className={css.logoutIcon} />
              <p
                style={{ color: fontColor }}
                className={isClosed ? css.menuTextHidden : css.menuText}
              >
                Logout
              </p>
            </div>

            <div
              style={{ overflow: 'hidden', border: `1px solid ${fontColor}` }}
              className={css.horizontalLine}
            ></div>

            <div className={css.menuItemContainer}>
              <ContactSupport
                className={css.contactSupportIcon}
                fill={fontColor}
              />
              <p
                className={isClosed ? css.menuTextHidden : css.menuText}
                style={{ color: fontColor }}
              >
                Contact Support
              </p>
            </div>

            <div
              style={{ color: fontColor }}
              className={css.supportItemsContainer}
            >
              {!isClosed ? (
                <span
                  style={{ marginLeft: '50px', color: fontColor }}
                  className={css.supportItems}
                >
                  <span
                    style={{ color: fontColor, cursor: 'pointer' }}
                    className={css.supportItems}
                    onClick={handleEmailClick}
                  >
                    support@certifid.com
                  </span>
                  <br />
                  <span
                    style={{ color: fontColor, cursor: 'pointer' }}
                    className={css.supportItems}
                    onClick={handlePhoneClick}
                  >
                    1-616-816-1668
                  </span>
                </span>
              ) : null}
            </div>
          </>
        );
      }
    }
  }

  function menuBarStyling() {
    if (isMobile) {
      return !isClosed ? 'menu-nav-bar__content' : css.contentClosedMobile;
    } else if (!isMobile) {
      return !isClosed ? 'menu-nav-bar__content' : css.contentClosedDesktop;
    }
  }

  return (
    <div id="outer-container">
      <main
        style={{ backgroundColor: 'white' }}
        id="page-wrap"
        className={`menu-nav-bar__page-wrap ${
          isClosed ? '' : 'menu-toggle-open'
        }`}
      >
        {isMobile ? (
          <div
            className={
              !isClosed
                ? css.whiteMobileCanvas_MENU_OPEN
                : css.whiteMobileCanvas_MENU_CLOSED
            }
          ></div>
        ) : null}
        <div
          style={{ backgroundColor: accentColor }}
          className="menu-nav-bar__grey-bar"
        >
          <div className={menuBarStyling()}>
            <div
              style={isClosed ? { marginBottom: '30px' } : null}
              className="menu-toggle-btn-wrapper"
            >
              <button
                style={{ backgroundColor: accentColor }}
                className="menu-toggle-btn"
                onClick={() =>
                  isClosed ? dispatch(openNavbar()) : dispatch(closeNavbar())
                }
              >
                <i
                  style={{ color: fontColor, backgroundColor: accentColor }}
                  className="fa fa-angle-double-right"
                ></i>
              </button>
            </div>

            {/* Added the div wrapper */}
            {returnLinkItems()}
          </div>
        </div>
        {props.children}
      </main>
    </div>
  );
};

export default withRouter(MenuNavBar);
